import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { AssetsFileResolver } from '../../application/containers/AssetsFileResolver';

const Image = styled.img`
  position: absolute;
  bottom: 0;
`;

class Poster extends React.Component {
  static propTypes = {
    alt: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
  };

  state = {
    hasError: false,
  };

  onError = () => {
    this.setState({ hasError: true });
  };

  render() {
    const { alt, src, ...props } = this.props;
    const { hasError } = this.state;

    if (!hasError) {
      return <Image {...props} alt={alt} src={src} onError={this.onError} />;
    }
    return <AssetsFileResolver {...props} alt={alt} path="images/placeHolder.png" />;
  }
}

export default Poster;
